import React from 'react';
import { Skeleton } from '@mui/material';
import { useOrder } from '@/hooks/order';
import { ServiceErrorView } from '@/components/atoms/Error';
import Invoice from '@/components/organisms/order/Invoice';
import BuyerPaymentBreakdown from '@/components/organisms/order/BuyerPaymentBreakDown';
import BuyerPayment from '@/components/organisms/order/BuyerPayment';
import Refund from '@/components/organisms/order/Refund';
import DeliveryAddressHome from '@/components/organisms/order/DeliveryAddressHome';
import DeliveryAddressPickup from '@/components/organisms/order/DeliveryAddressPickup';
import ActionLog from '../item/ActionLog';
import ChargeBack from './ChargeBack';

const View: React.FC<{ id: number }> = ({ id }) => {
  const data = useOrder(id);

  return (
    <>
      {data.kind === 'Called' && (
        <Skeleton
          height={100}
          variant="rounded"
        />
      )}
      {data.kind === 'Error' && <ServiceErrorView error={data.error} />}
      {data.kind === 'Loaded' && (
        <>
          <Invoice order={data.data} />
          <BuyerPaymentBreakdown order={data.data} />
          <BuyerPayment order={data.data} />
          <ChargeBack order={data.data} />
          <Refund order={data.data} />
          <DeliveryAddressHome order={data.data} />
          <DeliveryAddressPickup order={data.data} />
          <ActionLog
            id={id}
            type="order"
          />
        </>
      )}
    </>
  );
};

export default View;
